<template>
  <div>
    <br />

    <h2 class="ViewHeading">Water Management Services</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >
      <b-card no-body>
        <b-tabs card fill>
          <b-tab
            active
            :disabled="
              !UserAccess.includes('WMW') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
            lazy
          >
            <template #title>
              <b-row><b-col><BIconClipboardData
                font-scale="1rem"
                id="WaterTestHeader"
              ></BIconClipboardData></b-col></b-row>
              <b-row><b-col>Water Testing</b-col></b-row>
            </template>
            <TestingResults></TestingResults>
          </b-tab>

          <b-tab
            lazy
            :disabled="
              !UserAccess.includes('WMT') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
          >
            <template #title>
              <b-row><b-col><BIconThermometerHalf
                font-scale="1rem"
                id="ManualTempHeader"
              ></BIconThermometerHalf></b-col></b-row>
              <b-row><b-col>Manual Temperature</b-col></b-row>
            </template>
            <ManualTemps></ManualTemps>
          </b-tab>
          <b-tab
            lazy
            :disabled="
              !UserAccess.includes('WMR') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
          >
            <template #title>
              <b-row><b-col><BIconExclamationSquare
                font-scale="1rem"
                id="RiskAssessmentHeader"
              ></BIconExclamationSquare></b-col></b-row>
              <b-row><b-col>Risk Assessment</b-col></b-row>
            </template>
            <RiskAsessments></RiskAsessments>
          </b-tab>
          <b-tab
            lazy
            :disabled="
              !UserAccess.includes('WMS') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
          >
            <template #title>
              <b-row><b-col><BIconWater font-scale="1rem" id="ShowerHeader"></BIconWater></b-col></b-row>
              <b-row><b-col>Showers</b-col></b-row>
            </template>
            <ShowerAccessories></ShowerAccessories>
          </b-tab>
          <b-tab
            lazy
            :disabled="
              !UserAccess.includes('WMF') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
          >
            <template #title>
              <b-row><b-col><BIconFilterSquare
                font-scale="1rem"
                id="FilterHeader"
              ></BIconFilterSquare></b-col></b-row>
              <b-row><b-col>Filters</b-col></b-row>
            </template>
            <FilterManagement></FilterManagement>
          </b-tab>
          <b-tab
            lazy
            :disabled="
              !UserAccess.includes('WMA') &&
                !this.UserProfile.includes('SYS') &&
                !this.UserProfile.includes('SUP')
            "
          >
            <template #title>
              <b-row><b-col><BIconAlarm font-scale="1rem" id="RemedialHeader"></BIconAlarm></b-col></b-row>
              <b-row><b-col>Remedial Actions</b-col></b-row>
            </template>
            <RemedialActions></RemedialActions>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <b-tooltip target="WaterTestHeader" triggers="hover" placement="bottom"
      >Water Testing & Results</b-tooltip
    >
    <b-tooltip target="ManualTempHeader" triggers="hover" placement="bottom"
      >Manual Temperature Readings</b-tooltip
    >
    <b-tooltip target="RiskAssessmentHeader" triggers="hover" placement="bottom"
      >Risk Assessments</b-tooltip
    >
    <b-tooltip target="ShowerHeader" triggers="hover" placement="bottom"
      >Shower Accessories</b-tooltip
    >
    <b-tooltip target="FilterHeader" triggers="hover" placement="bottom"
      >Filter Management</b-tooltip
    >
    <b-tooltip target="RemedialHeader" triggers="hover" placement="bottom"
      >Remedial Actions</b-tooltip
    >
  </div>
</template>

<script>
import TestingResults from "../views/TestingResults.vue";
import RiskAsessments from "../views/RiskAssessments.vue";
import FilterManagement from "../views/FilterManagement.vue";
import RemedialActions from "../views/RemedialActions.vue";
import ShowerAccessories from "../views/ShowerAccessories.vue";
import ManualTemps from "../views/ManualTemperatures.vue";
import {
  BIconClipboardData,
  BIconExclamationSquare,
  BIconAlarm,
  BIconWater,
  BIconThermometerHalf,
  BIconFilterSquare,
} from "bootstrap-vue";

export default {
  computed: {},
  components: {
    TestingResults,
    RiskAsessments,
    FilterManagement,
    RemedialActions,
    ShowerAccessories,
    ManualTemps,
    BIconClipboardData,
    BIconExclamationSquare,
    BIconAlarm,
    BIconWater,
    BIconThermometerHalf,
    BIconFilterSquare,
  },

  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserAccess: localStorage.getItem("accessGroup"),
      UserProfile: localStorage.getItem("profileportal"),
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {},
};
</script>

<style></style>
